/**
 * Configurable transporter payable charge options.
 * Each charge needs an `id` (saved value), `text` (dropdown label) and `add_vat` flag.
 * `add_vat: true` will auto-check the VAT checkbox when the charge is selected.
 *
 * Edit this file to add, remove or rename the charges available to transporters.
 */
export const TRANSPORTER_PAYABLE_CHARGES = [
    { id: 'Transport Charges', text: 'TRANSPORT CHARGES', add_vat: true },
    { id: 'Offloading Charges', text: 'OFFLOADING CHARGES', add_vat: true },
    { id: 'Side loader Charges', text: 'SIDE LOADER CHARGES', add_vat: true },
    { id: 'Additional Transport', text: 'ADDITIONAL TRANSPORT', add_vat: true },
    { id: 'Additional Transport ETC ICD', text: 'ADDITIONAL TRANSPORT ETC ICD', add_vat: true },
    { id: 'Additional Transport TAUSI ICD', text: 'ADDITIONAL TRANSPORT TAUSI ICD', add_vat: true },
    { id: 'Additional Transport HECO ICD', text: 'ADDITIONAL TRANSPORT HECO ICD', add_vat: true },
    { id: 'Additional Offloading', text: 'ADDITIONAL OFFLOADING', add_vat: true },
    { id: 'Empty Drop Off Facilitation', text: 'EMPTY DROP OFF FACILITATION', add_vat: true },
    { id: 'Weighbridge Facilitation', text: 'WEIGHBRIDGE FACILITATION', add_vat: true },
    { id: 'Waiting Charges', text: 'WAITING CHARGES', add_vat: true },
    { id: 'Toll Fee', text: 'TOLL FEE', add_vat: true }
];

export const TRANSPORTER_CASH_PAYABLE_CHARGES = [
    { id: 'Empty Drop Off Facilitation', text: 'EMPTY DROP OFF FACILITATION', add_vat: false },
    { id: 'Weighbridge Facilitation', text: 'WEIGHBRIDGE FACILITATION', add_vat: false },
    { id: 'Toll Fee', text: 'TOLL FEE', add_vat: false }
];

/**
 * Transporter Invoicing configuration.
 * Update the values here to control what the Pending tab shows.
 */
export const TRANSPORTER_INVOICING_CONFIG = {
    // Only display pending jobs whose release_date is on or after this date.
    // Use dd-mm-yyyy format, e.g. '01-01-2026'.
    // Set to null or an empty string to show all pending jobs.
    PENDING_RELEASE_DATE_FROM: '17-08-2026',
};
